import { Card, Tabs } from "antd";
import ChaptersList from "./ChaptersList";
import { DeleteOutlined, GlobalOutlined, LeftOutlined, LockOutlined,MenuOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import DeletedChapter from "./DeletedChapter";


export default function Chapters() {


  const Navigate = useNavigate();
    const location = useLocation();
  const course_title =
    location.state?.title || localStorage.getItem("course_title") || "Course";

  const items = [
    {
      key: '1',
      label: 'Chapters',
      children: <ChaptersList />,
    },
    // {
    //   key: '2',
    //   label: 'Deleted Chapters',
    //   children: <DeletedChapter />,
    // },
  ]

  const onChange = key => {
    console.log(key);
  };

  return (
    <div className="lms-body">
      <Card>
        <h2>
          <span style={{ cursor: "pointer" }} onClick={() => Navigate("/courses")}>
            <LeftOutlined />
          </span>
          {course_title} - Chapters
        </h2>

        <Tabs defaultActiveKey="1" items={items} onChange={onChange} />

      </Card>
    </div>
  );
} 
